export const MILLISECONDS_IN_SECOND = 1000;
export const SECOND_IN_MINUTE = 60;
export const HALF_HOUR = 30 * SECOND_IN_MINUTE * MILLISECONDS_IN_SECOND;
